import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _slicedToArray from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '@/assets/images/activity/gift_bg.png';
import _imports_1 from '@/assets/images/activity/random_card_front.png';
import _imports_2 from '@/assets/images/activity/random_card_back.png';
var _hoisted_1 = {
  class: "h-full"
};
var _hoisted_2 = {
  class: "activity-sharing-main"
};
var _hoisted_3 = {
  class: "go-to-use"
};
var _hoisted_4 = {
  class: "card-wrap"
};
var _hoisted_5 = ["id", "onClick"];
import { ref, computed, watch } from "vue";
import LoopSwipe from "@/components/activity/LoopSwipe.vue";
import { isLogin } from "@/utils/authUtil";
import { participateRandomCouponActivity } from "@/api/activity";
import { useRouter } from "@/hooks/useRouter";
import { USER_ALREADY_PARTICIPATED_ACTIVITY } from "@/constant/responseCode";
import Dialog from "@/components/activity/dialog";
import GiftBgDialog from "@/components/activity/GiftBgDialog.vue";
import { Login } from "@/components/login/LoginDialog";
import { useI18n } from "vue-i18n";
export default {
  __name: 'RandomCoupon',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var _useRouter = useRouter(),
      routerPush = _useRouter.routerPush;
    var activityInfo = ref(window.__ACTIVITY_INFO__);
    var hasSelected = ref(false);
    var selectedIndex = ref(-1);
    function selectCard(index) {
      if (["ended", "ineffective"].includes(activityInfo.value.activity_status)) {
        Dialog.confirm({
          title: t("activityHasExpired"),
          okText: t("getMoreVouchers"),
          withoutCancel: true,
          closeOnClickOverlay: false,
          onOk: handleGoHome
        });
        return;
      }
      if (hasSelected.value) {
        return;
      }
      if (isLogin()) {
        afterLogin(index);
      } else {
        Login.open({
          onSuccess: function onSuccess() {
            afterLogin(index);
          }
        });
      }
    }
    function openCard(index) {
      hasSelected.value = true;
      selectedIndex.value = index;
      var dom = document.getElementById("card".concat(index));
      var scrollTop = document.documentElement.scrollTop;
      if (dom) {
        // 计算弹窗transition开始位置
        giftBgDialogStyle.value = _objectSpread(_objectSpread({}, giftBgDialogStyle.value), {}, {
          left: dom.offsetLeft + dom.offsetWidth / 2 + "px",
          top: dom.offsetTop - scrollTop + dom.offsetHeight / 2 + "px"
        });
      }
    }
    var winCouponInfo = ref();
    var giftDialogTitle = computed(function () {
      return winCouponInfo.value ? $t("congratulationsGetAcoupon") : t("sorryNoCoupons");
    });
    var giftDialogButtonText = computed(function () {
      return winCouponInfo.value ? t("goToUse") : t("getMoreVouchers");
    });
    function afterLogin(_x) {
      return _afterLogin.apply(this, arguments);
    }
    function _afterLogin() {
      _afterLogin = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(index) {
        var _yield$Promise$all, _yield$Promise$all2, res, _res$data$coupon;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              openCard(index);
              _context.next = 3;
              return Promise.all([participateRandomCouponActivity({
                activity_id: activityInfo.value.activity_id
              }), new Promise(function (resolve) {
                return setTimeout(resolve, 800);
              })]);
            case 3:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
              res = _yield$Promise$all2[0];
              if (res.isOK) {
                if (res.data.is_winning) {
                  winCouponInfo.value = (_res$data$coupon = res.data.coupon) === null || _res$data$coupon === void 0 ? void 0 : _res$data$coupon.coupon_info;
                  isGiftDialogVisible.value = true;
                } else {
                  isGiftDialogVisible.value = true;
                }
              } else if (res.code === USER_ALREADY_PARTICIPATED_ACTIVITY) {
                Dialog.confirm({
                  title: t("alreadyParticipatedInThisActivity"),
                  okText: t("getMoreVouchers"),
                  withoutCancel: true,
                  closeOnClickOverlay: false,
                  onOk: handleGoHome
                });
              } else {
                Dialog.confirm({
                  title: t("activityHasExpired"),
                  okText: t("getMoreVouchers"),
                  withoutCancel: true,
                  closeOnClickOverlay: false,
                  onOk: handleGoHome
                });
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _afterLogin.apply(this, arguments);
    }
    var isGiftDialogVisible = ref(false);
    var giftBgDialogStyle = ref({
      transform: "translate(-50%, -50%) scale(0)",
      transition: "all 0.3s",
      right: "unset"
    });
    watch(isGiftDialogVisible, function (val) {
      if (val) {
        // 计算弹窗transition结束位置
        setTimeout(function () {
          giftBgDialogStyle.value = _objectSpread(_objectSpread({}, giftBgDialogStyle.value), {}, {
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%) scale(1)"
          });
        }, 50);
      }
    });
    function handleClickButton() {
      if (winCouponInfo.value) {
        window.location.replace("".concat(window.location.origin).concat(window.location.pathname).concat(window.location.search, "#/home/index"));
        window.location.assign("".concat(window.location.origin).concat(window.location.pathname).concat(window.location.search, "#/my_coupon"));
      } else {
        handleGoHome();
      }
    }
    function handleGoHome() {
      routerPush({
        name: "Index"
      });
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_0,
        class: "asset-preload"
      }, null, -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, function (i) {
        return _createElementVNode("div", {
          id: "card".concat(i),
          key: i,
          class: _normalizeClass(["card", {
            'card--selected': i === selectedIndex.value
          }]),
          onClick: function onClick($event) {
            return selectCard(i);
          }
        }, _cache[1] || (_cache[1] = [_createElementVNode("div", {
          class: "side front"
        }, [_createElementVNode("img", {
          src: _imports_1,
          alt: ""
        })], -1), _createElementVNode("div", {
          class: "side back"
        }, [_createElementVNode("img", {
          src: _imports_2,
          alt: ""
        })], -1)]), 10, _hoisted_5);
      }), 64))])])]), _createVNode(LoopSwipe), _createVNode(GiftBgDialog, {
        visible: isGiftDialogVisible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return isGiftDialogVisible.value = $event;
        }),
        style: _normalizeStyle(giftBgDialogStyle.value),
        title: giftDialogTitle.value,
        "button-text": giftDialogButtonText.value,
        coupon: winCouponInfo.value,
        "close-on-click-overlay": false,
        onClickButton: handleClickButton
      }, null, 8, ["visible", "style", "title", "button-text", "coupon"])]);
    };
  }
};